export type StatusTone = "ok" | "info" | "warn" | "danger" | "neutral";

const TONE_COLOR: Record<StatusTone, string> = {
  ok: "var(--color-ok)",
  info: "var(--accent-blue)",
  warn: "var(--color-warn)",
  danger: "var(--color-danger)",
  neutral: "var(--color-text-faint)",
};

export interface StatusIndicatorProps {
  tone: StatusTone;
  label: string;
  mono?: boolean;
}

/** Dot-plus-label status indicator. The label always carries the meaning; color never carries it alone. */
export function StatusIndicator({ tone, label, mono }: StatusIndicatorProps) {
  return (
    <span className="status-indicator">
      <span
        className="status-indicator-dot"
        style={{ background: TONE_COLOR[tone] }}
        aria-hidden="true"
      />
      <span className={mono ? "cell-mono" : undefined}>{label}</span>
    </span>
  );
}
